export default "__VITE_ASSET__$Qh6rXPz__"